var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgApproveReopeningConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.161,
    height: 71.811,
    viewBox: "0 0 90.161 71.811"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-approve-reopening-confirm_svg__cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:1.6px;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-approve-reopening-confirm_svg__ICN_Modal_confirmare_Aproba_Redeschiderea",
    "data-name": "ICN_Modal confirmare Aproba Redeschiderea",
    transform: "translate(-1016 -168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-approve-reopening-confirm_svg__ICN_Modal_confirmare_Cere_Redeschiderea-_Acces_Enabled",
    "data-name": "ICN_Modal confirmare Cere Redeschiderea- Acces_Enabled",
    transform: "translate(73.08 -228.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-approve-reopening-confirm_svg__Path_948",
    "data-name": "Path 948",
    d: "M44.5 13.39a4 4 0 016.929 0l41.11 63.81a4 4 0 01-3.465 6H6.926a4 4 0 01-3.465-6z",
    transform: "translate(940 385)",
    fill: "#987002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-approve-reopening-confirm_svg__ICN_Redeschide_Enabled",
    transform: "translate(1172 1445.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-approve-reopening-confirm_svg__Rectangle_255",
    "data-name": "Rectangle 255",
    transform: "translate(-121 -1237.378)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.654,
    height: 16.656,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 18.054,
    height: 15.056,
    rx: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-approve-reopening-confirm_svg__Path_825",
    "data-name": "Path 825",
    className: "kpmg-approve-reopening-confirm_svg__cls-3",
    d: "M-118.058-1238.438v-3.346a5.525 5.525 0 015.477-5.424 5.317 5.317 0 015.477 4.149",
    transform: "translate(1.305 1.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-approve-reopening-confirm_svg__Path_1006",
    "data-name": "Path 1006",
    className: "kpmg-approve-reopening-confirm_svg__cls-3",
    d: "M-3652.132-18358.432l4.1 4.094 6.966-6.967",
    transform: "translate(3535.272 17128.857)"
  })))));
}

export default SvgKpmgApproveReopeningConfirm;